import * as React from "react";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import _ from 'lodash';
import moment from "moment-timezone";

import AppointmentList from "./AppointmentList";
import * as types from "../../constants/actionTypes";
import * as msgs from "../../constants/textConstants";
import * as Tools from "../../helpers/Tools";
import { inList, SAME_DAY_CARE_ID } from "../../helpers/data";
import { formatDoctorName, getCsnId, formatPhoneNumber } from "../../helpers/formatting";
import { logUI } from "../../api/andyliticsApi";
import DropdownForm from "../common/inputv2/DropDownForm";
import DropdownTypeahead from "../common/inputv2/DropdownTypeadhead";
import MiniSpinner from "../common/MiniSpinner";
import YesNoModal from "../common/YesNoComponent";
import ShareVideoVisitModal from "./ShareVideoVisitModal";
import GuestLinkModal from "../care/GuestLinkModal";
import OnTheFlyVisitModal from '../care/OnTheFlyVisitModal';

/**
 * Main app menu. Expects props to contain an array of strings identifying the menu items to enable.
 */
class Menu extends React.Component {
    constructor(props) {
        super(props);

        //this.serverData = this.props.serverData;
        this.toggleMainMenu = this.toggleMainMenu.bind(this);
        this.hideMainMenu = this.hideMainMenu.bind(this);
        this.mapOfActiveHead = this.mapOfActiveHead.bind(this);
        this.throttle = _.throttle(this.handleResize.bind(this), 150);
        this.menuOnClick = this.menuOnClick.bind(this);
        this.expandMenu = this.expandMenu.bind(this);

        this.patientId = null;
        this.currentPharmacyId = null;
        this.isMobile = false;
        this.windowHeight = 0;
        const location = window ? window.location.pathname === "/login" ? "/" : window.location.pathname : "/";
        let activeMenuValues = this.mapOfActiveHead(location);
        let initialState = {
            activePath: location,
            activeItem: activeMenuValues.activeItem,
            activeSleekMenu: activeMenuValues.activeSleekMenu
        };
        if (initialState.activeSleekMenu !== "") {
            initialState = {
                ...initialState,
                showMainMenu: false
            };
        }

        this.state = {
            showMainMenu: initialState.showMainMenu ? initialState.showMainMenu : false,
            activePath: initialState.activePath,
            activeItem: initialState.activeItem,
            activeSleekMenu: initialState.activeSleekMenu,
            providers: null,
            allProviders: null, //{ name: 'All Providers', displayName: 'All Providers' },
            allDepartments: null, //{ displayName: 'All Departments', selected: true },
            sameDayCareDepartment: null, //{ displayName: 'Same Day Care', selected: false },
            lanId: props.location && props.location.search,
            providerInfoLoading: true,
            linkToCancel: null,
            linkToReSend: null,
            showFlyVisitModal: false,
            showTodaysAppointments: true,
            showTomorrowsAppointments: true
        };

        this.patientWasInRoom = {};
    }

    componentDidMount() {
        if (typeof window !== 'undefined') {
            window.addEventListener('resize', this.throttle);
        }

        this.historyUnListen = this.props.history.listen((location, action) => {
            this.updateMenus();
            const { pathname } = location;
            const { showCollapsedMenu } = this.props;

            if (pathname && (pathname === "/terms" || pathname === "/privacy" || pathname === "/disclosures" || pathname === "/faq" || pathname === "/customerservice")) {
                this.setState({ activeItem: "fromfooter", activePath: "anynonexistingmenu", activeSleekMenu: '' });
            }

            if (pathname) {
                if (pathname !== "/videovisittips" && showCollapsedMenu) {
                    this.expandMenu(false);
                } else if (pathname === "/videovisittips" && this.state.showMainMenu) {
                    this.setState({
                        showMainMenu: !this.state.showMainMenu
                    });
                }
            }

        });

        this.getProviderInfo();

        const { fullDepartmentList, loadingFullDepartmentList, loadFullDepartmentList, employeeRole, getShareLinkHistory } = this.props;
        if (employeeRole === 'staff' && !fullDepartmentList && !loadingFullDepartmentList) {
            loadFullDepartmentList();
        }

        if (this.state.activeItem) {
            getShareLinkHistory(this.state.activeItem);
        }
    }

    componentDidUpdate() {
        const { currentUser, currentPharmacyUser } = this.props;
        const patientId = currentUser ? currentUser.dn : null;
        const currentPharmacyId = currentPharmacyUser ? currentPharmacyUser.pharmacyPatientId : '';
        this.updateMenus();
        if (patientId && patientId !== this.patientId) {
            this.patientId = patientId;
            this.handleResize();
        } else if (currentPharmacyId !== this.currentPharmacyId) {
            this.currentPharmacyId = currentPharmacyId;
            this.handleResize();
        }

        const { fullDepartmentList, loadingFullDepartmentList, loadFullDepartmentList, providerDepartments, lastLoadingDepartmentsError, employeeRole } = this.props;
        if (employeeRole === 'staff' && !fullDepartmentList && !loadingFullDepartmentList && !lastLoadingDepartmentsError) {
            loadFullDepartmentList();
        }
    }

    getProviderInfo() {
        const urlParams = new URLSearchParams(window.location.search.toLowerCase());
        const lanId = urlParams.get('lanid');
        this.setState({ providerInfoLoading: true });
        this.props.getProviderInfo(lanId, () => this.setState({ providerInfoLoading: false, refreshingAppointments: false }));
    }

    componentWillUnmount() {
        if (typeof window !== 'undefined') {
            window.removeEventListener('resize', this.throttle);
        }
        if (this.historyUnListen) {
            this.historyUnListen();
        }
    }

    isPartOfSameDayCare() {
        const sdcGroups = window.serverData.data.sameDayGroups.split(";");
        const allGroups = this.props.ADGroups;
        if (allGroups) {
            for (let i = 0; i < sdcGroups.length; i++) {
                const sdcGroup = sdcGroups[i].trim().toLowerCase();
                for (let j = 0; j < allGroups.length; j++) {
                    if (allGroups[j].toLowerCase() === sdcGroup) {
                        return true;
                    }
                }
            }
        }
        return false;
    }

    expandMenu(value) {
        const { expandMenu } = this.props;
        if (expandMenu)
            expandMenu(value);
    }

    updateMenus() {
        const { currentLocation, updateMenu } = this.props;
        const { activePath } = this.state;
        const isApptPage = location.href.indexOf("/providervideovisit") > -1;
        const actualPath = (location.pathname.split("/").length > 2) ? location.pathname.substring(0, location.pathname.indexOf("/", 2)) : location.pathname;
        let pathName = '';
        if (location && location.pathname) {
            if (isApptPage) { // Need full path name if video visit page
                pathName = location.pathname;
            } else {
                pathName = location.pathname === "/login" ? "/" : actualPath;
            }
        } else {
            pathName = "/";
        }
        let parentMenu = this.getImmediateParent(pathName);

        if (activePath && (activePath.toLowerCase() !== pathName.toLowerCase() || currentLocation || (activePath.toLowerCase() === pathName.toLowerCase() && parentMenu))) {//handle refresh for non-navitem routes to select immediate parent if it has.
            if (!(parentMenu && parentMenu.toLowerCase() === activePath.toLowerCase() && activePath.toLowerCase() !== pathName.toLowerCase() && !currentLocation)) {
                let activeMenuValues = this.mapOfActiveHead(parentMenu ? parentMenu : pathName);

                updateMenu("");//reset
                if (activeMenuValues) {
                    //this.hideMainMenu();
                    this.setState({
                        activePath: parentMenu ? parentMenu : pathName,
                        activeItem: activeMenuValues.activeItem.replace('/', ''),
                        activeSleekMenu: activeMenuValues.activeSleekMenu
                    });
                }
            }

        }
    }

    /* Sets Parent of Child Pages Not Directly in Menu */
    getImmediateParent(childRoute) {
        switch (childRoute.toLowerCase()) {
            default:
                return "";
        }
    }

    handleResize(event) {
        if (typeof window !== 'undefined') {
            let windowWidth = window.innerWidth;

            // Check if mobile 
            if (windowWidth <= 768) {
                this.isMobile = true;
            }
            else {
                this.isMobile = false;
            }
        }
    }

    /* Nav Link Clicked */
    menuOnClick(e, item) {
        if (item.label.toLowerCase().trim() === "sign out") {
            this.props.onLogoutClick();
        } else {
            this.hideMainMenu();
        }
        logUI("UI.Menu." + item.label.replace(/\s+/g, '') + ".Clicked", new Date(), Tools.getURLPath());
    }

    /* Toggle Mobile Menu Open and Close */
    toggleMainMenu() {
        const { showCollapsedMenu } = this.props;
        if (showCollapsedMenu) {
            this.expandMenu(false);
        }
        this.setState({
            showMainMenu: !this.state.showMainMenu
        });
    }

    /* Close Mobile Menu */
    hideMainMenu(type) {
        this.setState({
            showMainMenu: false
        });
    }

    /* Set Active Menu Head and Sleek Submenu */
    mapOfActiveHead(activePath) {
        const videoPageUrl = "/providervideovisit";
        if (activePath.toLowerCase().indexOf(videoPageUrl) !== -1) {
            return {
                activeItem: getCsnId(activePath),
                activeSleekMenu: ""
            };
        } else {
            switch (activePath.toLowerCase()) {
                case "/":
                    return {
                        activeItem: "",
                        activeSleekMenu: ""
                    };
                default:
                    return {
                        activeItem: "",
                        activeSleekMenu: ""
                    };
            }
        }
    }

    onGenericDepartmentsDropdownDismissed = (allDepartments, genericDepartments, sameDayCareDepartment) => {
        this.setState({});
        //this.setState({ allDepartments, genericDepartments, sameDayCareDepartment });
        //const selectedList = genericDepartments.filter(d => d.selected);
        //let epicIds = [];
        //let activeStatus = false;
        //for (let i = 0; i < selectedList.length; i++) {
        //    if (selectedList[i].genericProviders) {
        //        epicIds = epicIds.concat(selectedList[i].genericProviders.map(p => p.id));
        //    }
        //    if (selectedList[i].providerInDeptStatus === 'Active') {
        //        activeStatus = true;
        //    }
        //}
        //if (activeStatus || allDepartments.selected) {
        //    epicIds.push(this.props.employeeEpicId);
        //}
        //if (sameDayCareDepartment && sameDayCareDepartment.selected) {
        //    epicIds.push('153284');
        //}
        //this.props.setProviderEpicIds(epicIds, this.refreshCallback);        
    }

    onDepartmentSelected = (department) => {
        this.setState({ department, allProviders: null, providers: null, selectedProviders: null, selectedProviderIds: null });
        this.props.getProviders(department.id);
    }

    onProvidersSelection = (allProviders, providers) => {
        const selectedProviders = providers.filter(item => item.selected);
        this.setState({
            allProviders, providers, selectedProviders,
            selectedProviderIds: selectedProviders.map(provider => ({ providerExternalId: provider.externalId, departmentInternalId: this.state.department.id })),
            showAppointments: false
        });
    }

    getAppointmentsForStaff = (sync) => {
        this.setState({ loadingAppointments: true }, () => {
            if (this.state.selectedProviderIds) {
                if (sync) {
                    this.props.sync(false, false, () => this.props.setProviderEpicIds(this.state.selectedProviderIds, this.refreshCallback));
                }
                else {
                    this.props.setProviderEpicIds(this.state.selectedProviderIds, this.refreshCallback);
                }
            }
            else {
                const { providers } = this.props;
                if (providers && providers.list && providers.list.length === 1) {
                    const selectedProviders = [providers.list[0]];
                    const selectedProviderIds = selectedProviders.map(provider => ({ providerExternalId: provider.externalId, departmentInternalId: this.state.department.id }));
                    this.setState({ selectedProviders, selectedProviderIds });
                    if (sync) {
                        const callback = () => this.props.setProviderEpicIds(selectedProviderIds, this.refreshCallback);
                        this.props.sync(false, false, callback);
                    }
                    else {
                        this.props.setProviderEpicIds(selectedProviderIds, this.refreshCallback);
                    }
                }
            }
        });
    }

    refresh(syncSameDayCare) {
        logUI("UI.VideoVisit.Refresh.Click", new Date(), Tools.getURLPath(), { syncSameDayCare: syncSameDayCare });
        this.setState({ refreshingAppointments: true });
        if (this.props.providerInfoError) {
            this.getProviderInfo();
        }
        else {
            if (this.props.employeeRole !== 'staff') {
                this.props.sync(syncSameDayCare, true, this.refreshCallback);
            }
            else {
                this.getAppointmentsForStaff(true);
            }
        }
    }

    refreshCallback = () => {
        this.setState({ refreshingAppointments: false, showAppointments: true, loadingAppointments: false });
    }

    cancelLink(linkInfo) {
        linkInfo.canceling = true;
        this.setState({ linkToCancel: null });
        this.props.cancelLink(linkInfo.id, () => {
            const roomId = getCsnId(this.props.location.pathname);
            if (roomId) {
                this.props.getShareLinkHistory(roomId);
            }
            linkInfo.canceling = false;
        });
    }

    render() {
        const {
            showCollapsedMenu, hideApptMenu, loadingProviderAppointments, loadingSameDayCareAppointments, appointments, sameDayCareAppointments,
            isProviderAppointmentsSuccess, isSDCAppointmentsSuccess, isProviderAppointmentsFailure, isSDCAppointmentsFailure, postLoginProcessCompleted,
            employeeRole, fullDepartmentList, providerInfo, providerInfoSuccess, providerInfoError, sdcAllowed, employeeName, instaDocToken, employeeEpicId, createVirtualRoom
        } = this.props;
        const { showMainMenu, activeSleekMenu, showShareVideoVisitModal, refreshingAppointments, department, showTodaysAppointments, showTomorrowsAppointments,
            selectedProviders, selectedProviderIds, showAppointments, loadingAppointments, providerInfoLoading, linkToCancel, linkToReSend
        } = this.state;
        const isStaff = employeeRole === 'staff';
        const providers = this.state.providers ? this.state.providers : this.props.providers && this.props.providers.list;
        const allProviders = this.state.allProviders ? this.state.allProviders : this.props.providers && this.props.providers.header;
        const genericDepartments = /*this.state.genericDepartments ? this.state.genericDepartments : */providerInfo;

        const mobileMenuOpenClass = showMainMenu ? " menu-open" : " menu-closed";
        const displayClass = hideApptMenu ? " hidden" : "";
        const menuCollapseClass = showCollapsedMenu ? " menu-collapsed" : "";

        const allDepartments = this.state.allDepartments || (genericDepartments && genericDepartments.length && genericDepartments.filter(d => d.isAll)[0]);
        const sameDayCareDepartment = (genericDepartments && genericDepartments.length && genericDepartments.filter(d => d.isSameDayCare)[0]) || { id: '1034002261', name: 'SAME DAY CARE', displayName: "SAME DAY CARE", isSameDayCare: true };
        const sameDayCare = !isStaff && sameDayCareDepartment && (sameDayCareDepartment.selected || (sdcAllowed && (!genericDepartments || !genericDepartments.length))) ? '/sameDayCare' : '';
        const nonSdcDepartments = genericDepartments && genericDepartments.length && genericDepartments.filter(d => !d.isAll && !d.isSameDayCare);
        const selectedDepartments = sameDayCareDepartment && sameDayCareDepartment.selected ? [sameDayCareDepartment] : nonSdcDepartments && nonSdcDepartments.length ? nonSdcDepartments.filter(d => d.selected) : null;
        const oneDepartment = (selectedDepartments && selectedDepartments.length === 1 && selectedDepartments[0].name) ||
            ((!selectedDepartments || selectedDepartments.length === 0) && (genericDepartments && genericDepartments.length === 2 && genericDepartments[1].name));
        const selectedDepartmentIds = isStaff ? (department ? department.id : '') : selectedDepartments ? selectedDepartments.map(dep => dep.id) : nonSdcDepartments ? nonSdcDepartments.map(dep => dep.id) : '';
        const todaysDay = moment()._d.toDateString();
        const tomorrowsDay = moment().add(1, 'days')._d.toDateString();
        const isSameDayCare = (sameDayCareDepartment && (sameDayCareDepartment.selected || selectedDepartmentIds === '1034002261')) || oneDepartment === 'SAME DAY CARE';
        const todaysAppointments = isSameDayCare
            ? sameDayCareAppointments.filter(appointment => moment(appointment.apptDateTime)._d.toDateString() == todaysDay)
            : appointments && appointments.filter(appointment =>
                ((allDepartments && allDepartments.selected) || (nonSdcDepartments && nonSdcDepartments.map(dep => dep.selected && dep.id).indexOf(appointment.deptId) > -1)));
        const tomorrowsAppointments = isSameDayCare
            ? sameDayCareAppointments.filter(appointment => moment(appointment.apptDateTime)._d.toDateString() == tomorrowsDay)
            : null;
        const noAppointments = isProviderAppointmentsSuccess && todaysAppointments && todaysAppointments !== undefined && todaysAppointments.length === 0;
        const noAppointmentText = (!oneDepartment && nonSdcDepartments && nonSdcDepartments.length > 0 && (!selectedDepartments || selectedDepartments.length === 0) && 'Please select one or more departments.') ||
            (noAppointments && 'There are no appointments ' + (oneDepartment ? ` for ${oneDepartment}.` : 'for the selected departments.'));
        const showDeptDropdown = !providerInfoError && !providerInfoLoading && (!isStaff || fullDepartmentList);// || (((genericDepartments && genericDepartments.length > 0))/* && !noAppointments*/);
        const failedToLoadProviderAppts = providerInfoError || (!isProviderAppointmentsSuccess && isProviderAppointmentsFailure);
        const failedToLoadSDCAppts = !isSDCAppointmentsSuccess && isSDCAppointmentsFailure;
        const failureMessage = !providerInfoLoading && providerInfoSuccess && !refreshingAppointments && (
            !employeeRole ? 'Employee info request failed due to type.' : (failedToLoadProviderAppts || failedToLoadSDCAppts) && 'Your appointments failed to load.'
        );
        const showApptLoader = refreshingAppointments || loadingAppointments || providerInfoLoading ||
            ((!postLoginProcessCompleted || loadingProviderAppointments || loadingSameDayCareAppointments) && (!isProviderAppointmentsSuccess || !isSDCAppointmentsSuccess));

        return (
            <div className={"appt-menu-container menu" + mobileMenuOpenClass + displayClass + menuCollapseClass}>
                <div className="appt-menu-header">
                    <div className="appt-menu-btn" onClick={this.toggleMainMenu}>
                        <div className="hamburger">
                            <div className="hamburger-inner">
                                <span />
                                <span />
                                <span />
                            </div>
                        </div>
                    </div>
                </div>
                {showCollapsedMenu && <button type="button" className="appt-menu-list btn text-btn" onClick={() => this.expandMenu(false)} aria-label="Expand menu">
                    <div className="expand-btn">
                        <div className="icon-col"><span className="icon-expand-left-menu" /></div>
                        <div className="details-col">EXPAND</div>
                    </div>
                </button>
                }
                {(!showCollapsedMenu || showMainMenu) && <div className={"appt-menu-list " + (activeSleekMenu !== "" ? "sleek-menu-open" : "")}>
                    {failureMessage && <div className="appt-tryagain-banner">{failureMessage}</div>}
                    {showDeptDropdown
                        ? <div className={"appt-menu-form " + (!sdcAllowed && "appt-menu-divider")}>
                            {isStaff
                                ? showAppointments ? null : <div className="form-group"><DropdownTypeahead name="Department" textFieldName="name" listItems={fullDepartmentList}
                                    selectedItem={department} onDismiss={this.onDepartmentsTypeaheadDismissed} onItemSelected={this.onDepartmentSelected}
                                /></div>
                                : <div className="form-group">
                                    <DropdownForm name="Department" headerItem={allDepartments} footerItem={sdcAllowed ? sameDayCareDepartment : null}
                                        listItems={nonSdcDepartments} textFieldName="displayName" multiSelect className={sdcAllowed ? "" : "appt-sdc-btn"}
                                        onDismiss={this.onGenericDepartmentsDropdownDismissed}
                                    />
                                </div>
                            }
                            {isStaff && (showAppointments
                                ? <div className="appt-menu-form-selection" onClick={() => this.setState({ showAppointments: false })}>
                                    <div className="appt-selection__details">
                                        <div className="appt-selection__provider truncate">
                                            {((selectedProviderIds.length === 1 && selectedProviders && selectedProviders[0].name) ? formatDoctorName(selectedProviders[0].name) : selectedProviderIds.length + ' Providers Selected')}
                                        </div>
                                        <div className="appt-selection__department truncate">{department.n}</div>
                                    </div>
                                    <div className="appt-selection__icon">
                                        <span className="icon-edit" />
                                    </div>
                                </div>
                                : this.props.providers && !this.props.providers.isWaiting && <>
                                    <div className="form-group">
                                        <DropdownForm name="Provider" textFieldName="displayName" headerItem={allProviders} showClearBtn
                                            multiSelect listItems={providers} onDismiss={this.onProvidersSelection} onClear={this.onProvidersSelection}
                                        />
                                    </div>
                                    {providers && (providers.length === 1 || (selectedProviderIds && selectedProviderIds.length > 0)) &&
                                        <div className="form-group">
                                            <button className="btn btn-provider-primary" disabled={loadingAppointments} onClick={() => this.getAppointmentsForStaff()}>View Appointments</button>
                                        </div>
                                    }
                                </>
                            )}
                        </div>
                        : <div className="appt-spinner"><MiniSpinner /></div>
                    }
                    <div className="appt-list-container">
                        {!failedToLoadProviderAppts && (sdcAllowed || (nonSdcDepartments && nonSdcDepartments.length > 0)) && ((!isStaff && !providerInfoLoading) || showAppointments) && <>
                            <div className="appt-menu-title">
                                <div type="button" className="btn btn-primary" onClick={() => this.setState({ showTodaysAppointments: !showTodaysAppointments })}>
                                    Today's Appointments
                                    {showApptLoader
                                        ? <MiniSpinner className="appointment-mini-spinner" />
                                        : (!isStaff || showAppointments) && serverData.data.enableRefreshButton &&
                                        <button type="button" className="btn btn-icon-only sync-button" aria-label="Sync appointments"
                                            onClick={e => { e.stopPropagation(); this.refresh(isSameDayCare); }}><span className="icon-refresh" />
                                        </button>
                                    }
                                </div>
                            </div>
                            {showTodaysAppointments && todaysAppointments && todaysAppointments.length > 0 &&
                                <AppointmentList
                                    appointments={todaysAppointments} sameDayCare={sameDayCare}
                                    setAppointment={appointment => this.setState({ appointment })}
                                    setActiveSleekMenu={activeSleekMenu => this.setState({ activeSleekMenu })}
                                    setShowShareVideoVisitModal={showShareVideoVisitModal => this.setState({ showShareVideoVisitModal })}
                                    setLinkToReSend={linkToReSend => this.setState({ linkToReSend })}
                                    setLinkToCancel={linkToCancel => this.setState({ linkToCancel })}
                                />
                            }
                            {isStaff
                                ? showAppointments && todaysAppointments && todaysAppointments.length === 0 &&
                                <div className="appt-no-appointment-txt">The selected provider{selectedProviderIds.length > 1 ? 's have' : ' has'} no appointments today.</div>
                                : (sdcAllowed || (genericDepartments && genericDepartments.length > 0)) && noAppointmentText && !providerInfoLoading && <div className="appt-no-appointment-txt">{noAppointmentText}</div>
                            }
                            {tomorrowsAppointments && tomorrowsAppointments.length > 0 && <>
                                <div className="appt-menu-title">
                                    <div type="button" className="btn btn-primary" onClick={() => this.setState({ showTomorrowsAppointments: !showTomorrowsAppointments })}>
                                        Tomorrow's Appointments
                                        {showApptLoader
                                            ? <MiniSpinner className="appointment-mini-spinner" />
                                            : (!isStaff || showAppointments) && serverData.data.enableRefreshButton &&
                                            <button type="button" className="btn btn-icon-only sync-button" aria-label="Sync appointments"
                                                onClick={e => { e.stopPropagation(); this.refresh(isSameDayCare); }}><span className="icon-refresh" />
                                            </button>
                                        }
                                    </div>
                                </div>
                                {showTomorrowsAppointments &&
                                    <AppointmentList
                                        appointments={tomorrowsAppointments} sameDayCare={sameDayCare}
                                        setAppointment={appointment => this.setState({ appointment })}
                                        setActiveSleekMenu={activeSleekMenu => this.setState({ activeSleekMenu })}
                                        setShowShareVideoVisitModal={showShareVideoVisitModal => this.setState({ showShareVideoVisitModal })}
                                        setLinkToReSend={linkToReSend => this.setState({ linkToReSend })}
                                        setLinkToCancel={linkToCancel => this.setState({ linkToCancel })}
                                    />
                                }
                            </>}
                        </>}
                    </div>
                    {((window.serverData && window.serverData.data && (window.serverData.data.enableOnTheFlyVisit || window.serverData.data.enableVisitHistory)) && ((!isStaff && this.props.employeeEpicId) || isStaff)) &&
                        <>
                            <div className="past-appointment-container">
                                {window.serverData.data.enableOnTheFlyVisit && (!isStaff && this.props.employeeEpicId) &&
                                    <>
                                        <button type="button" className="btn text-btn" onClick={() => {
                                            logUI("UI.VideoVisit.OnTheFlyBtn.Clicked", new Date(), Tools.getURLPath());
                                            this.hideMainMenu();
                                            this.setState({ showFlyVisitModal: true });
                                        }} aria-label="On the fly">
                                            <div className="icon-col"><span className="icon-circle-plus" /></div>
                                            <div className="details-col">ON THE FLY</div>
                                        </button>
                                        <div className="separator" />
                                    </>
                                }
                                {window.serverData.data.enableVisitHistory &&
                                    <>
                                        <Link className="past-appt-btn" to={{ pathname: `/providervideovisit/history/${selectedDepartmentIds.toString(',')}${isStaff ? (selectedProviderIds ? '/' + selectedProviderIds.map(p => p.providerExternalId).toString(',') : '') : (!sameDayCare && employeeEpicId ? '/' + employeeEpicId : '')}` }}
                                            onClick={() => {
                                                logUI("UI.VideoVisit.PastAppointment.Clicked", new Date(), Tools.getURLPath());
                                                this.hideMainMenu();
                                                if (!this.isMobile) {
                                                    this.expandMenu(true);
                                                }
                                            }}>
                                            <div className="icon-col"><span className="icon-clock" /></div>
                                            <div className="details-col">
                                                PAST APPOINTMENTS
                                            </div>
                                        </Link>
                                        <div className="separator" />
                                        <button type="button" className="collapse-btn btn text-btn" onClick={() => this.expandMenu(true)} aria-label="Collapse menu">
                                            <div className="icon-col"><span className="icon-collapse-left-menu" /></div>
                                            <div className="details-col">COLLAPSE</div>
                                        </button>
                                    </>
                                }
                            </div>
                        </>
                    }
                </div>
                }
                {linkToCancel &&
                    <YesNoModal showModal={linkToCancel !== null} className="cancel-add-guest-modal" title={(linkToCancel.token.participantRole && linkToCancel.token.participantRole.toLowerCase() === "patient" ? "Patient" : "Guest") + " Management"}
                        modalText={"Do you want to cancel invite to " + "<br />" +
                            "<strong>" +
                            (this.state.linkToCancel.target.indexOf('@') === -1 ? formatPhoneNumber(this.state.linkToCancel.target) : this.state.linkToCancel.target) +
                            "</strong>?"
                        }
                        modalYesFunction={() => this.cancelLink(this.state.linkToCancel)}
                        modalNoFunction={() => this.setState({ linkToCancel: null })}
                    />
                }
                {linkToReSend &&
                    <GuestLinkModal showModal={linkToReSend !== null} showModalStyle
                        title="Resend Link" participantRole={linkToReSend.item.token.participantRole}
                        guestName={linkToReSend.item.token.participantRole.toLowerCase() === 'patient' ? linkToReSend.item.token.participantName : linkToReSend.item.token.participantName}
                        emailOrNumber={linkToReSend.item.target}
                        csnIdOfAppointment={linkToReSend.item.token.roomId}
                        onDismiss={() => this.setState({ linkToReSend: null })}
                        onLinkSent={(message, isSuccess = true) => { this.setState({ linkToReSend: null }); this.hideMainMenu(); }}
                    />
                }
                {showShareVideoVisitModal &&
                    <ShareVideoVisitModal showModal={showShareVideoVisitModal} appointment={this.state.appointment}
                        onDismiss={() => this.setState({ showShareVideoVisitModal: false })}
                    />
                }
                {this.state.showFlyVisitModal && <OnTheFlyVisitModal employeeEpicId={employeeEpicId} createVirtualRoom={createVirtualRoom} employeeName={employeeName} token={instaDocToken} showModal={this.state.showFlyVisitModal} onDismiss={() => this.setState({ showFlyVisitModal: false })} />}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        serverData: state.session.serverData,
        bundle: state.session.serverData ? state.session.serverData.bundle : "mybswhealth",  // we'll default with rendering for mybswhealth
        isProxyUser: state.domain.ip,
        currentUser: state.domain.cu,
        instaDocToken: state.domain.idt,
        employeeEpicId: state.domain.eid,
        employeeRole: state.domain.er,
        currentLocation: state.common.currentLocation,
        fullDepartmentList: state.epic.departmentList,
        loadingFullDepartmentList: state.epic.loadingDepartmentList,
        providerInfo: state.videoVisit.providerInfo,
        providerInfoLoading: state.videoVisit.providerInfoLoading,
        providerInfoSuccess: state.videoVisit.providerInfoSuccess,
        providerInfoError: state.videoVisit.providerInfoError,
        sdcAllowed: state.videoVisit.sdcAllowed,
        providers: state.videoVisit.providers,
        shareLinkHistory: state.videoVisit.shareLinkHistory,
        loadingProviderAppointments: state.epic.loadingProviderAppointments,
        loadingSameDayCareAppointments: state.epic.loadingSameDayCareAppointments,
        appointments: state.epic.providerAppointments,
        providerDepartments: state.epic.providerDepartments,
        sameDayCareAppointments: state.epic.sameDayCareAppointments,
        showCollapsedMenu: state.common.showCollapsedMenu,
        isProviderAppointmentsSuccess: state.epic.isProviderAppointmentsSuccess,
        isProviderAppointmentsFailure: state.epic.isProviderAppointmentsFailure,
        isSDCAppointmentsSuccess: state.epic.isSDCAppointmentsSuccess,
        isSDCAppointmentsFailure: state.epic.isSDCAppointmentsFailure,
        postLoginProcessCompleted: state.sso.postLoginProcessCompleted,
        lastLoadingDepartmentsError: state.epic.lastLoadingDepartmentsError,
        ADGroups: state.session.adg,
        roomStatuses: state.portal.roomStatuses,
        smsVideoVisitLink: state.videoVisit.smsVideoVisitLink,
        emailVideoVisitLink: state.videoVisit.emailVideoVisitLink,
        smsVideoVisitLinkForGuest: state.videoVisit.smsVideoVisitLinkForGuest,
        emailVideoVisitLinkForGuest: state.videoVisit.emailVideoVisitLinkForGuest,
        employeeName: state.domain.pen
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onLogoutClick: () => {
            dispatch({ type: types.LOGOUT, logoutMessage: msgs.UserInitiatedLogoutMessage });
        },
        updateMenu: (currentLocation) => dispatch({ type: types.UPDATE_MENU, currentLocation }),
        loadFullDepartmentList: () => dispatch({ type: types.EPIC_DEPT_LIST_GET_START }),
        getProviders: departmentId => dispatch({ type: types.INSTADOC_PROVIDERS_START, departmentId: departmentId }),
        getProviderInfo: (lanId, callback) => dispatch({ type: types.INSTADOC_PROVIDER_INFO_START, lanId, callback }),
        setProviderEpicIds: (providerEpicIds, callback) => dispatch({ type: types.SET_PROVIDER_EPIC_IDS, providerEpicIds, callback }),
        expandMenu: (value) => dispatch({ type: types.COLLAPSE_MENU, showCollapsedMenu: value }),
        sync: (syncSameDayCare, shouldRefresh, callback) => dispatch({ type: types.SYNC_ROOMS, syncSameDayCare, shouldRefresh, callback }),
        getShareLinkHistory: (room) => dispatch({ type: types.VIDEO_VISIT_SHARE_LINK_HISTORY, room }),
        sendSms: (room, participantName, mobileNumber, participantRole, callback) => {
            if (participantRole && participantRole.toLowerCase() === 'patient') {
                dispatch({ type: types.SMS_VIDEO_VISIT_LINK, room, mobileNumber, participantName: participantName, callback });
            }
            else {
                dispatch({ type: types.SMS_VIDEO_VISIT_LINK_FOR_GUEST, room, guestName: participantName, mobileNumber, callback });
            }
        },
        sendEmail: (room, participantName, email, participantRole, callback) => {
            if (participantRole && participantRole.toLowerCase() === 'patient') {
                dispatch({ type: types.EMAIL_VIDEO_VISIT_LINK, room, email, participantName: participantName, callback });
            }
            else {
                dispatch({ type: types.EMAIL_VIDEO_VISIT_LINK_FOR_GUEST, room, guestName: participantName, email, callback });
            }
        },
        cancelLink: (shareCode, callback) => dispatch({ type: types.CANCEL_VIDEO_VISIT_LINK, shareCode, callback }),
        setVideoVisitToastrMsg: (message, successStatus) => dispatch({ type: types.SET_VIDEO_VISIT_TOASTR_MSG, message, successStatus }),
        createVirtualRoom: (payload) => dispatch({ type: types.CREATE_VIRTUAL_ROOM, payload }),
        refreshRooms: (data) => dispatch({ type: types.APPOINTMENTS_REFRESH_DATA, data })
    };
};

const MenuHOC = connect(
    mapStateToProps,
    mapDispatchToProps
)(Menu);

export default withRouter(MenuHOC);